import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, Teleport as _Teleport, openBlock as _openBlock, createBlock as _createBlock, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "hotel" }
const _hoisted_2 = { class: "hotel-infos__left-container" }
const _hoisted_3 = { class: "hotel-infos__name" }
const _hoisted_4 = { class: "hotel__details-container" }

import OfferBox from '@lmt-rpb/OfferBox/OfferBox.vue';
import {
	scrollToAnchorWithDynamicOffset as scrollToAnchorWithDynamicOffsetOriginal,
	scrollIt,
	scrollToHashWithDynamicOffset,
} from '@utils/utils';
import { EventBus } from '@global-js/event-bus';
import { ref, computed, onMounted, watch } from 'vue';
import type { HotelData } from '@interfaces/offer-list-types/offer-list-typo-hotel-data';
import StickyOfferButton from '@lmt-rpb/StickyOfferButton/StickyOfferButton.vue';
import { OFFER_BOX_TELEPORT } from '@global-js/constants';
import { useStore } from '@/components/common/store';
import type { MergedOfferItemData } from '@/interfaces/offer';
import { useBoundaryObserver } from '@/js/composables/boundaryObserver';
import { useSearchParams } from '../../../../storybook/src/composables/searchParams';
import HotelFeaturesSocial from './internals/HotelFeaturesSocial.vue';
import SelectContentAnalytics from '@/js/modules/analytics/SelectContentAnalytics';
import { storeToRefs } from 'pinia';
import { useBreakpointStore } from 'src/store/breakpointsStore';

interface Props {
	hotel: HotelData;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'HotelFeatures',
  props: {
    hotel: {}
  },
  setup(__props: any) {

const props = __props;

const store = useStore();

const initialRender = ref(true);

const urlPathname = ref('');

const urlSearchParams = useSearchParams(true);
const { isMobile, isDesktop } = storeToRefs(useBreakpointStore());
const offerBoxTeleportAddress = computed(() =>
	isDesktop.value ? `.${OFFER_BOX_TELEPORT.HOTEL_DESCRIPTION}` : `.${OFFER_BOX_TELEPORT.HOTEL_INFOS}`
);

const attributesContainer = ref<HTMLElement | null>(null);
const animationInProgress = ref(false);
const animationEndCallback = () => {
	animationInProgress.value = false;
};
const { isInBounds: needStickyButton } = useBoundaryObserver({ elementRef: attributesContainer, shouldBeVisible: false });
const scrollToAnchorWithDynamicOffset = (event: MouseEvent): void => {
	animationInProgress.value = true;
	scrollToAnchorWithDynamicOffsetOriginal(event, animationEndCallback);
};

const isPackage = props.hotel.SeasonSettings.TravelType === 'Package';

const bestOffer = computed((): Partial<MergedOfferItemData> => {
	let hotelDataOffer: Partial<MergedOfferItemData> = {};
	if (props.hotel?.PackageOffer || props.hotel?.AccommodationOffer) {
		const offer = isPackage ? props.hotel.PackageOffer : props.hotel.AccommodationOffer;
		hotelDataOffer = {
			BoardType: offer.BoardType,
			Room: {
				Type: offer.Room?.Type,
				Name: offer.Room?.Name,
				View: offer.Room?.View,
			},
			CurrencyCode: offer.CurrencyCode,
			duration: 'BetweenDeparturesDuration' in offer ? offer.BetweenDeparturesDuration : offer.OvernightStays,
			Price: offer.Price,
		};
	}
	const emptyOffer = {
		BoardType: undefined,
		Room: undefined,
		CurrencyCode: undefined,
		duration: undefined,
		Price: undefined,
	};

	if (initialRender.value) {
		return store.state.bestOffer ? store.state.bestOffer : hotelDataOffer;
	}
	return store.state.bestOffer ? store.state.bestOffer : emptyOffer;
});

watch(
	() => store.state.bestOffer,
	() => {
		initialRender.value = false;
	}
);
const offerBoxBtnAnalytics = () => {
	SelectContentAnalytics.selectContent({ cId: 'offerbox_button' });
};

const offerBoxLinkAnalytics = () => {
	SelectContentAnalytics.selectContent({ cId: 'offerbox_link' });
};

const onSearchUpdateClick = () => {
	offerBoxBtnAnalytics();
	scrollToHashWithDynamicOffset('offers');
};

const onUpdatePackage = () => {
	offerBoxLinkAnalytics();
	if (!isDesktop.value) {
		EventBus.$emit('SearchMask:MobileSubmit');
	}
	scrollToHashWithDynamicOffset('offers');
};

onMounted((): void => {
	urlPathname.value = window.location.pathname;
	const urlHash = window.location.href.split('#')[1];
	const targetElement = document.querySelector(`#${urlHash}`) as HTMLElement;
	if (targetElement) {
		setTimeout(() => {
			scrollIt(targetElement, 0, 'linear', 50);
		}, 10);
	}
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        (_openBlock(), _createBlock(_Teleport, {
          to: _unref(isMobile) ? '#hotel-info-container' : '.hotel-page-main-content__menu > ul'
        }, [
          _createVNode(HotelFeaturesSocial, {
            hotel: _ctx.hotel,
            "best-offer": bestOffer.value
          }, null, 8 /* PROPS */, ["hotel", "best-offer"])
        ], 8 /* PROPS */, ["to"]))
      ]),
      _createElementVNode("div", _hoisted_4, [
        (!animationInProgress.value && bestOffer.value && bestOffer.value.Price && bestOffer.value.CurrencyCode)
          ? (_openBlock(), _createBlock(StickyOfferButton, {
              key: 0,
              visible: _unref(needStickyButton)
            }, null, 8 /* PROPS */, ["visible"]))
          : _createCommentVNode("v-if", true),
        (_openBlock(), _createBlock(_Teleport, {
          to: offerBoxTeleportAddress.value,
          defer: "",
          disabled: _unref(isMobile)
        }, [
          _createElementVNode("div", {
            ref_key: "attributesContainer",
            ref: attributesContainer,
            class: "hotel-infos__offer-box"
          }, [
            _createVNode(OfferBox, {
              "all-offers-href": `${urlPathname.value}${_unref(urlSearchParams)}#offers`,
              onSearchUpdateClick: onSearchUpdateClick,
              onPackageSwitchClick: onUpdatePackage,
              onShowOffersClick: _cache[0] || (_cache[0] = (event) => (offerBoxBtnAnalytics(), scrollToAnchorWithDynamicOffset(event)))
            }, null, 8 /* PROPS */, ["all-offers-href"])
          ], 512 /* NEED_PATCH */)
        ], 8 /* PROPS */, ["to", "disabled"]))
      ])
    ])
  ]))
}
}

})